export default __webpack_public_path__ + "static/media/NHILL.49f60052.jpg";